module.exports = __webpack_public_path__ + "static/city_icon_97-35c1575a16b47f06e87ff26e09a521a8.png";